import ConfigurationWrapper from '../3modules/Config/ConfigurationWrapper'
import useConfiguration from '../../services/configPage/useConfiguration'
import WelcomeMessageAccordion from '../3modules/Config/WelcomeMessageAccordion'
import useTemplateConfig from '../../services/configPage/useTemplateConfig'

const ApplicationConfiguration = () => {
  const {
    onEditMode,
    setOnEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    isLoading,
    setIsLoading
  } = useConfiguration()
  const {
    title,
    setTitle,
    description,
    setDescription,
    footerDescription,
    setFooterDescription,
    handleCancel,
    templateName,
    setTemplateName,
    templateOption,
    setTemplateOption,
    templateOptions,
    formik
  } = useTemplateConfig(
    onEditMode,
    setOnEditMode,
    setIsSnackbarOpen,
    setIsLoading
  )

  return (
    <form onSubmit={formik.handleSubmit}>
      <ConfigurationWrapper
        header={'Application Configuration'}
        onEditMode={onEditMode}
        setOnEditMode={setOnEditMode}
        handleCancel={handleCancel}
        isSnackbarOpen={isSnackbarOpen}
        setIsSnackbarOpen={setIsSnackbarOpen}
        isLoading={isLoading}
      >
        <WelcomeMessageAccordion
          onEditMode={onEditMode}
          title={title}
          setTitle={setTitle}
          description={description}
          setDescription={setDescription}
          footerDescription={footerDescription}
          setFooterDescription={setFooterDescription}
          templateName={templateName}
          setTemplateName={setTemplateName}
          templateOption={templateOption}
          setTemplateOption={setTemplateOption}
          templateOptions={templateOptions}
          formik={formik}
        />
      </ConfigurationWrapper>
    </form>
  )
}

export default ApplicationConfiguration
